import { gql } from '@apollo/client'

const COACH_PREFERENCES = gql`
  query CoachSettings {
    currentUser {
      attributes {
        ... on Coach {
          bookingUrl
          freeTierLimitsReached
          googleCalendarConnected
          preferences {
            bookNowEnabled
            acceptsLeads
            leadAutoReplyEnabled
          }
        }
      }
    }
  }
`

const UPDATE_COACH_PREF = gql`
  mutation UpdateCoachPreferences($input: CoachPreferencesInput!) {
    updateCoachPreferences(input: $input) {
      success
      message
      coach {
        preferences {
          acceptsLeads
          bookNowEnabled
        }
      }
    }
  }
`

// --- Leads Auto-Reply specific queries ---
const LEAD_REPLY_PREFERENCES_QUERY = gql`
  query CoachSettings {
    currentUser {
      attributes {
        ... on Coach {
          preferences {
            leadAutoReplyEnabled
            leadAutoReplyMessage
            leadAutoReplyIncludeBookingLink
          }
        }
      }
    }
  }
`

const UPDATE_LEAD_REPLY_PREFERENCES = gql`
  mutation UpdateCoachPreferences($input: CoachPreferencesInput!) {
    updateCoachPreferences(input: $input) {
      success
      message
      coach {
        preferences {
          leadAutoReplyEnabled
          leadAutoReplyMessage
          leadAutoReplyIncludeBookingLink
        }
      }
    }
  }
`

export {
  COACH_PREFERENCES,
  UPDATE_COACH_PREF,
  LEAD_REPLY_PREFERENCES_QUERY,
  UPDATE_LEAD_REPLY_PREFERENCES,
}
